import { transliterateText } from "./translateText";

// Keys we do NOT want to translate
const filterKeys = ["id", "Id", "Code", "icon", "type", "fieldType", "isRequired", "maxLength","minLength", "regex", "variableName", "value","url",
  "code","isDisabled","image", "route", "isMultipleFiles","CarrierCode", "CarrierQuoteId", "PlanCode", "PlanName", "PlanType", "ServiceType","BodyType",
  "IsModified", "IsNew", "PlateCode", "VehGCCYN", "Version", "IsInsured",
];

export const translateDataToArabic = async (data) => {
  if (sessionStorage.getItem("language") !== "ar") {
    return data;
  }

  const valuesToTranslate = [];
  const paths = [];

  const collectStrings = (obj, path = [], parentKey = null) => {
    if (typeof obj === "string") {
      // Skip if parent key is in filterKeys (case-insensitive match)
      if (!parentKey || !filterKeys.some(k => k.toLowerCase() === parentKey.toLowerCase())) {
        valuesToTranslate.push(obj);
        paths.push(path);
      }
    } 
    else if (Array.isArray(obj)) {
      obj.forEach((item, index) => collectStrings(item, [...path, index], parentKey));
    } 
    else if (typeof obj === "object" && obj !== null) {
      Object.entries(obj).forEach(([key, value]) => {
        collectStrings(value, [...path, key], key);
      });
    }
  };

  collectStrings(data);

  // ✅ Break into chunks (max 128 strings per API call)
  const CHUNK_SIZE = 128;
  let translatedValues = [];

  for (let i = 0; i < valuesToTranslate.length; i += CHUNK_SIZE) {
    const chunk = valuesToTranslate.slice(i, i + CHUNK_SIZE);
    const translatedChunk = await transliterateText(chunk, "ar");
    translatedValues = translatedValues.concat(translatedChunk);
  }

  // Replace original values with translated values
  const cloned = JSON.parse(JSON.stringify(data));
  let translatedIndex = 0;

  const replaceStrings = (obj, path = [], parentKey = null) => {
    if (typeof obj === "string") {
      if (!parentKey || !filterKeys.some(k => k.toLowerCase() === parentKey.toLowerCase())) {
        let target = cloned;
        for (let i = 0; i < path.length - 1; i++) {
          target = target[path[i]];
        }
        target[path[path.length - 1]] = translatedValues[translatedIndex++];
      }
    } 
    else if (Array.isArray(obj)) {
      obj.forEach((item, index) => replaceStrings(item, [...path, index], parentKey));
    } 
    else if (typeof obj === "object" && obj !== null) {
      Object.entries(obj).forEach(([key, value]) => {
        replaceStrings(value, [...path, key], key);
      });
    }
  };

  replaceStrings(data);

  return cloned;
};
